module.exports = __webpack_public_path__ + "static/media/CartFull.fca42d84.svg";